/**
 * Notification System
 */

class Notifications {
    constructor() {
        this._container = document.getElementById('notifications');
        this._notifications = [];
    }

    show(message, type = 'info', duration = 3000) {
        const id = Date.now();
        const notification = { id, message, type };
        this._notifications.push(notification);
        this._render(notification);

        if (duration > 0) {
            setTimeout(() => this.dismiss(id), duration);
        }

        return id;
    }

    dismiss(id) {
        const index = this._notifications.findIndex(n => n.id === id);
        if (index === -1) return;

        const element = this._container.querySelector(`[data-id="${id}"]`);
        if (element) {
            element.style.opacity = '0';
            element.style.transform = 'translateX(20px)';
            setTimeout(() => {
                element.remove();
                this._notifications.splice(index, 1);
            }, 200);
        }
    }

    _render(notification) {
        const el = document.createElement('div');
        el.className = `notification ${notification.type}`;
        el.dataset.id = notification.id;
        el.innerHTML = `
            <span class="notification-message">${notification.message}</span>
            <button class="notification-close">&times;</button>
        `;

        el.querySelector('.notification-close').addEventListener('click', () => {
            this.dismiss(notification.id);
        });

        this._container.appendChild(el);
    }

    success(message, duration) {
        return this.show(message, 'success', duration);
    }

    error(message, duration = 5000) {
        return this.show(message, 'error', duration);
    }

    warning(message, duration) {
        return this.show(message, 'warning', duration);
    }

    info(message, duration) {
        return this.show(message, 'info', duration);
    }
}

export const notifications = new Notifications();
